import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { ThemeProvider } from "@emotion/react";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { Analytics } from '@vercel/analytics/react';
// import { AuthProvider } from "../core/context/AuthContext";
// import { CookieProvider } from "../core/context/CookieContext";

// Tema escuro forçado para toda a aplicação
const darkTheme = createTheme({
  typography: {
    button: {
      textTransform: "none",
    },
    fontFamily: [
      '"Poppins"',
      'sans-serif'
    ].join(','),
  },
  palette: {
    mode: 'dark', // Força o tema escuro
    primary: {
      main: "#BA0006",
      light: "#BA0006",
      dark: "#940005",
    },
    secondary: {
      main: "#0058D0",
      light: "#939094",
    },
    background: {
      default: "#121212", // Fundo escuro padrão
      paper: "#1e1e1e",   // Superfícies ligeiramente mais claras
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1300,
      xl: 1536,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#121212",
          color: "#FFFFFF",
          fontFamily: '"Poppins", sans-serif',
        },
        ':root': {
          colorScheme: 'dark', // Forçar esquema de cores escuro em nível de navegador
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1e1e1e",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: "#333333",
        },
        head: {
          backgroundColor: "#222222",
        },
        body: {
          backgroundColor: "#1e1e1e",
        },
      },
    },
  },
});

export default function App({ Component, pageProps }: AppProps) {
  return (
    <MuiThemeProvider theme={darkTheme}>
      <CssBaseline />
      <ThemeProvider theme={darkTheme}>
        <Component {...pageProps} />
        <Analytics />
      </ThemeProvider>
    </MuiThemeProvider>
  );
}
